<template>
    <div class="what">
        <legend class="v-label theme--light mt-5 mb-0 pb-0" style="font-size: 14px">{{ $attrs.label }}</legend>
        <v-radio-group v-model="radioGroupSelectedValue" :value="radioData" v-bind="$attrs" required column>
            <template #label>
                {{ ' ' }}
            </template>
            <div v-for="(item, index) in radioData" :key="index">
                <v-radio :label="item.label" :value="item.value" color="primary"></v-radio>
                <ul v-if="item.info">
                    <li v-for="(infoText, idx) in item.info" :key="idx">{{ infoText }}</li>
                </ul>
            </div>
        </v-radio-group>
    </div>
</template>

<script>
export default {
    name: 'SecureSignFormRadioGroup',
    props: {
        toMutate: {
            type: String,
            required: true,
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false,
        },
        radioData: {
            type: Array,
            required: true,
            default: () => [],
        },
        connectedField: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            store: null,
            propertyToMutate: null,
        };
    },
    computed: {
        radioGroupSelectedValue: {
            get() {
                return _.get(this.$store.state[this.store], this.propertyToMutate);
            },
            set(value) {
                this.$store.dispatch(`${this.store}/updateProperty`, { value, property: this.propertyToMutate });
                if (this.connectedField)
                    this.$store.dispatch(`${this.store}/updateProperty`, { value: '', property: this.connectedField });
            },
        },
        errorMessage() {
            const propertyToMutate =
                this.propertyToMutate !== this.toMutate.split('::')[1]
                    ? this.toMutate.split('::')[1]
                    : this.propertyToMutate;
            return _.get(this.$store.state[this.store].errorMessages, propertyToMutate);
        },
    },
    created() {
        [this.store, this.propertyToMutate] = this.toMutate.split('::');
    },
};
</script>

<style scoped lang="scss">
.what::v-deep {
    .v-input__slot {
        margin-bottom: 0 !important;
        width: auto !important;
        cursor: default !important;
    }

    .v-input--radio-group__input {
        width: auto !important;
    }

    .v-messages {
        min-height: 0 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-radio {
        margin-right: auto;

        .v-label {
            margin-bottom: 0 !important;
        }
    }
}
</style>
